module.exports = __webpack_public_path__ + "static/digifarm-5ba68c0b92cec777541ea342c358b5be.png";